// MARK://dhk8/pos/lib/print/receipt-opts
// Resuelve los datos del header del ticket (logo, nombre comercial, dirección
// operativa, RFC, razón social, régimen fiscal) para un tenant dado. Se llama
// desde FastBarPage / OrderPage al renderizar el ticket digital + impreso.
//
// Fuentes en orden de prioridad:
//   1. Tabla `dhk8_platform_tenants.TenantFiscalProfile` (TODO Lane 85 — endpoint
//      `/v1/me/fiscal-profile`). Hoy NO existe, así que cae al fallback hardcoded.
//   2. Fallback hardcoded por tenantId conocido (SAVIs LIVE + TEST). Único tenant
//      productivo hoy; cualquier otro tenant nuevo cae al default genérico.
//   3. Default genérico (solo branding name + logo, sin datos fiscales).
//
// Cuando el endpoint del paso 1 exista, esta función se vuelve async y reemplaza
// el fallback. Por ahora, mantener la lógica acá centralizada hace fácil migrar.

import { getBranding } from '../branding-loader.js'
import type { RenderOpts } from './templates.js'

const SAVIS_LIVE_TENANT = 'a24e5485-12cf-45a8-b10b-01b90a68b77d'
const SAVIS_TEST_TENANT = '019e5c6c-7e80-7d22-af2b-303a2a06dfc4'

const SAVIS_FISCAL = {
  businessName: "SAVI's Coffee GDL",
  branchName: 'Av. México 2305-A',
  businessAddress: 'Av. México 2305-A, Ladrón de Guevara, 44600,\nGuadalajara, Jalisco',
  legalName: 'ABRAHAM CARACHURE MEJIA',
  rfc: 'CAMA930627235',
  regimeFiscal: '612 — Personas Físicas con Actividades Empresariales',
} as const

/** Resuelve opciones de header para el ticket del tenant activo. */
export function getReceiptOpts(tenantId: string | null | undefined): RenderOpts {
  const brand = getBranding()
  // Base común: logo del branding + nombre del branding como fallback.
  const base: RenderOpts = {
    businessName: brand.name,
    ...(brand.logoUrl ? { logoUrl: brand.logoUrl } : {}),
  }
  if (tenantId === SAVIS_LIVE_TENANT || tenantId === SAVIS_TEST_TENANT) {
    return { ...base, ...SAVIS_FISCAL }
  }
  return base
}
